import PropTypes from 'prop-types';

const DocumentSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_504_6899)">
        <path
          d="M52.6367 5.28516V68.4492C52.6367 69.5818 51.7185 70.5 50.5859 70.5H2.73438C1.6018 70.5 0.683594 69.5818 0.683594 68.4492V6.65234C0.683594 3.25994 3.44354 0.5 6.83594 0.5H57.4219C54.7791 0.5 52.6367 2.64238 52.6367 5.28516ZM59.7461 31.3984V57.1686C59.7461 60.2677 60.7053 63.284 62.4805 65.81H66.582C68.3572 63.284 69.3164 60.2677 69.3164 57.1686V31.3984H59.7461ZM66.582 21.1445V19.0938C66.582 17.9612 65.6638 17.043 64.5312 17.043C63.3987 17.043 62.4805 17.9612 62.4805 19.0938V21.1445H66.582Z"
          fill="url(#paint0_linear_504_6899)"
        />
        <path
          d="M66.582 65.81V68.3125C66.582 69.4451 65.6638 70.3633 64.5312 70.3633C63.3987 70.3633 62.4805 69.4451 62.4805 68.3125V65.81H66.582ZM67.2656 21.1445H61.7969C60.6643 21.1445 59.7461 22.0627 59.7461 23.1953V31.3984H69.3164V23.1953C69.3164 22.0627 68.3982 21.1445 67.2656 21.1445ZM62.207 13.4883V5.28516C62.207 2.64238 60.0646 0.5 57.4219 0.5C54.7791 0.5 52.6367 2.64238 52.6367 5.28516V15.5391H60.1562C61.2888 15.5391 62.207 14.6209 62.207 13.4883ZM22.5586 37.5508C21.426 37.5508 20.5078 36.6326 20.5078 35.5C20.5078 34.3674 21.426 33.4492 22.5586 33.4492H24.6094V17.7266L22.4219 19.3672C22.0668 19.6334 21.6351 19.7773 21.1914 19.7773H17.7734V23.8789H18.457C19.5896 23.8789 20.5078 24.7971 20.5078 25.9297C20.5078 27.0623 19.5896 27.9805 18.457 27.9805H12.9883C11.8557 27.9805 10.9375 27.0623 10.9375 25.9297C10.9375 24.7971 11.8557 23.8789 12.9883 23.8789H13.6719V19.7773H12.9883C11.8557 19.7773 10.9375 18.8591 10.9375 17.7266C10.9375 16.594 11.8557 15.6758 12.9883 15.6758H20.5078L24.6094 12.5996V10.8906C24.6094 9.75805 25.5276 8.83984 26.6602 8.83984C27.7927 8.83984 28.7109 9.75805 28.7109 10.8906V12.5996L32.8125 15.6758H40.332C41.4646 15.6758 42.3828 16.594 42.3828 17.7266C42.3828 18.8591 41.4646 19.7773 40.332 19.7773H39.6484V23.8789H40.332C41.4646 23.8789 42.3828 24.7971 42.3828 25.9297C42.3828 27.0623 41.4646 27.9805 40.332 27.9805H34.8633C33.7307 27.9805 32.8125 27.0623 32.8125 25.9297C32.8125 24.7971 33.7307 23.8789 34.8633 23.8789H35.5469V19.7773H32.1289C31.6853 19.7773 31.2535 19.6334 30.8984 19.3672L28.7109 17.7266V33.4492H30.7617C31.8943 33.4492 32.8125 34.3674 32.8125 35.5C32.8125 36.6326 31.8943 37.5508 30.7617 37.5508H22.5586ZM17.7734 43.7031C17.7734 44.8357 16.8552 45.7539 15.7227 45.7539H10.2539C9.12133 45.7539 8.20312 44.8357 8.20312 43.7031C8.20312 42.5705 9.12133 41.6523 10.2539 41.6523H15.7227C16.8552 41.6523 17.7734 42.5705 17.7734 43.7031ZM17.7734 51.9062C17.7734 53.0388 16.8552 53.957 15.7227 53.957H10.2539C9.12133 53.957 8.20312 53.0388 8.20312 51.9062C8.20312 50.7737 9.12133 49.8555 10.2539 49.8555H15.7227C16.8552 49.8555 17.7734 50.7737 17.7734 51.9062ZM17.7734 60.1094C17.7734 61.242 16.8552 62.1602 15.7227 62.1602H10.2539C9.12133 62.1602 8.20312 61.242 8.20312 60.1094C8.20312 58.9768 9.12133 58.0586 10.2539 58.0586H15.7227C16.8552 58.0586 17.7734 58.9768 17.7734 60.1094ZM23.9258 41.6523H43.0664C44.199 41.6523 45.1172 42.5705 45.1172 43.7031C45.1172 44.8357 44.199 45.7539 43.0664 45.7539H23.9258C22.7932 45.7539 21.875 44.8357 21.875 43.7031C21.875 42.5705 22.7932 41.6523 23.9258 41.6523ZM45.1172 51.9062C45.1172 53.0388 44.199 53.957 43.0664 53.957H23.9258C22.7932 53.957 21.875 53.0388 21.875 51.9062C21.875 50.7737 22.7932 49.8555 23.9258 49.8555H43.0664C44.199 49.8555 45.1172 50.7737 45.1172 51.9062ZM45.1172 60.1094C45.1172 61.242 44.199 62.1602 43.0664 62.1602H23.9258C22.7932 62.1602 21.875 61.242 21.875 60.1094C21.875 58.9768 22.7932 58.0586 23.9258 58.0586H43.0664C44.199 58.0586 45.1172 58.9768 45.1172 60.1094Z"
          fill="url(#paint1_linear_504_6899)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_504_6899"
          x1="1.29557"
          y1="69.8684"
          x2="61.4318"
          y2="10.9066"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_504_6899"
          x1="22.2544"
          y1="54.2929"
          x2="74.7561"
          y2="8.36666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          {/*<stop offset="0.5028" stopColor="#C7D4EC" />*/}
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <clipPath id="clip0_504_6899">
          <rect
            width="70"
            height="70"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

DocumentSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default DocumentSvg;
